import Vue from "vue";
import Axios from "axios"; //引入axios插件
import hmacSHA256 from 'crypto-js/hmac-sha256'
import qs from 'qs'
// import { API_ROOT, COMPANY_KEY, API_USER} from "./config"; //引入axios全局配置
const REQUEST = Axios.create(); //创建一个axios对象
REQUEST.defaults.baseURL = API_ROOT; //域名，或ip地址
REQUEST.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'; //请求头
REQUEST.defaults.timeout = 60000;
// REQUEST.defaults.transformResponse = function (data) {
//   console.log(data)
//   return {};
// }
REQUEST.interceptors.request.use(config => {
    if (config.method == "post") {
        config.timeout = 60000000
    }
    return config
}, err => {
    if (err) return Promise.reject(err)
})
// XMLHttpRequest
// 数据加密
import encryption from "./encryption";

// 服务对象
const service = {
    // 登录方法
    /**
     * 调用如下
     *   login() {
              this.$_api.login("/api/system/login",{
                username: this.username,
                userPwd: encryption.sha1(this.password),
              })
              .then(res=>{
                请求成功执行的方法
              })
              }
     */
    login(data) {
        // let params = {
        //     action: data.method,
        //     usr: data.usr,
        // };
        // let pwd = encryption.sha1(data.userPwd);
        // let action = "&action=" + params.action + "&usr=" + encodeURIComponent(params.usr);
        // let salt = new Date().getTime();
        // let url = "?sign=" + this.getloginsign(pwd, action, salt) + "&salt=" + salt + '&company-key=' + COMPANY_KEY;
        // return REQUEST({
        //     baseURL: API_USER,
        //     url: url, //二级路径，会加baseURL后面，即'http://api.shinemonitor.com/public/+url。
        //     // 如果url =/api/system/login，即'http://api.shinemonitor.com/public/api/system/login这种形式
        //     params: params, //请求参数。params是会将参数直接加url后面，data则会放在post请求体里面，即post请求的body里面
        // })
        //     .then(result => this.handleSucc(result))
        //     .catch(error => this.handleSucc(error));
        let params = {
            account: data.usr,
            password: encryption.sha1(data.userPwd),
            project: "AAM"
        }
        let url = "/ppr/login";
        return REQUEST({
            url: API_USER + url,
            method: "post",
            data: params,
            headers: {
                'Content-Type': 'application/json', // 单独设置 login 请求的 Content-Type
                'project': 'AAM'
            }
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleSucc(error));
    },
    get(data) {
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let _dataObj = {};
        let _dataObj1 = {};
        for (var key in data) {
            let _data = data[key];
            let type = (typeof _data === 'string' && (_data !== '')) || (typeof _data === 'number') || (typeof _data === 'boolean')
            if (type) {
                _dataObj[key] = _data.toString()
            }
            else if (Array.isArray(_data) && _data.length !== 0) {
                _dataObj1[key] = _data
            }
        }
        let action = Object.keys(_dataObj).map(key => {
            // let dat = encodeURIComponent(_dataObj[key]);
            let dat = _dataObj[key];
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token;
        let params = {
            ..._dataObj1,
            ..._dataObj,
        }
        console.log(params);

        return REQUEST({
            url: url, //二级路径，会加baseURL后面，即'http://api.shinemonitor.com/public/+url。
            // 如果url =/api/system/login，即'http://api.shinemonitor.com/public/api/system/login这种形式
            method: "get", //请求类型是post还是get还是put
            // params: _dataObj //请求参数。params是会将参数直接加url后面
            params,
            paramsSerializer: params => qs.stringify(params, { indices: false })
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    pnGet(urls, data, headers) {
        // let secret = sessionStorage.getItem("secret");
        // let token = sessionStorage.getItem("token");
        let _dataObj = {};
        let _dataObj1 = {};
        for (var key in data) {
            let _data = data[key];
            let type = (typeof _data === 'string' && (_data !== '')) || (typeof _data === 'number') || (typeof _data === 'boolean')
            if (type) {
                _dataObj[key] = _data.toString()
            }
            else if (Array.isArray(_data) && _data.length !== 0) {
                _dataObj1[key] = _data
            }
        }
        let action = Object.keys(_dataObj).map(key => {
            // let dat = encodeURIComponent(_dataObj[key]);
            let dat = _dataObj[key];
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        // let salt = new Date().getTime();
        // let url = urls + "?pn=" + data.pn;
        let params = {
            ..._dataObj1,
            ..._dataObj,
        }
        console.log('进来了');

        return REQUEST({
            url: urls, //二级路径，会加baseURL后面，即'http://api.shinemonitor.com/public/+url。
            // 如果url =/api/system/login，即'http://api.shinemonitor.com/public/api/system/login这种形式
            method: "get", //请求类型是post还是get还是put
            // params: _dataObj //请求参数。params是会将参数直接加url后面
            params,
            headers: {
                'i18n': headers.i18n
            },
            paramsSerializer: params => qs.stringify(params, { indices: false })
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    getNoSign(data) {
        let _dataObj = {};
        for (var key in data) {
            let _data = data[key];
            let type = (typeof _data === 'string' && (_data !== '')) || (typeof _data === 'number') || (typeof _data === 'boolean')
            if (type) {
                _dataObj[key] = _data.toString()
            }
        }
        let action = Object.keys(_dataObj).map(key => {
            // let dat = encodeURIComponent(_dataObj[key]);
            let dat = _dataObj[key];
            // dat = dat.replace(/%40/g, '@');
            // dat = dat.replace(/%3A/g, ':');
            // dat = dat.replace(/%24/g, '$');
            // dat = dat.replace(/%2C/g, ',');
            // dat = dat.replace(/%20/g, '+');
            // dat = dat.replace(/%5B/g, '[');
            // dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(action, '', '', salt) + "&salt=" + salt;
        return REQUEST({
            url: url,
            method: "get",
            params: _dataObj
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    post(data) {
        // post
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "&action=" + data.action;
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;
        //---------------------------
        let param = new URLSearchParams();
        for (var key in data.form) {
            param.append(key, data.form[key])
        }
        //--------------------------

        return REQUEST({
            url: url, //url地址即/api/system/login
            method: "post", //请求类型post或get
            data: param //post请求提交的数据对象,data则会放在post请求体里面，即post请求的body里面

        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    postJs(uri, data) {
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key]
            }
        }
        return Axios.post(API_APPURL + uri, data, {
            headers: {
                'Content-Type': 'application/json', // 明确指定表单数据格式
            }
        })
    },
    put(uri, data) {
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key]
            }
        }
        return Axios.put(API_APPURL + uri, data, {
            headers: {
                'Content-Type': 'application/json', // 明确指定表单数据格式
            }
        })
    },
    // 带签名的put方法
    putWithSign(data) {
        // put请求
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "&action=" + data.action;
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;

        // 构建表单数据
        let param = new URLSearchParams();
        for (var key in data.form) {
            param.append(key, data.form[key])
        }

        return REQUEST({
            url: url, // url地址即/api/system/login
            method: "put", // 请求类型为put
            data: param // put请求提交的数据对象
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    getJs(uri, data) {
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key]
            }
        }
        let params = {
            ...data
        }
        return Axios.get(API_APPURL + uri, { params })
    },
    getDownload(uri, data) {
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key]
            }
        }
        let params = {
            ...data
        }
        return Axios({
            method: 'get',
            url: API_APPURL + uri,
            params: params,
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            },
        })
    },
    postFMS(uri, data) {
        // 获取token和secret，但不设置到全局
        let token = sessionStorage.getItem('token');
        let secret = sessionStorage.getItem('secret');
        let sign = hmacSHA256(uri, secret).toString();

        // 设置FMS API baseURL for this request
        const originalBaseURL = Axios.defaults.baseURL;
        Axios.defaults.baseURL = FMS_API_ROOT;

        // 清理数据
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key];
            }
        }

        // 创建请求配置对象，包含headers
        const requestConfig = {
            headers: {
                'token': token,
                'project': 'FMS',
                'sign': sign
            }
        };

        // 发送请求，在headers中传递参数
        return Axios.post(uri, data, requestConfig)
            .finally(() => {
                Axios.defaults.baseURL = originalBaseURL;
            });
    },
    // TMS无鉴权接口
    postTMS(url, data) {
        for (let key in data) {
            if (data[key] === undefined || data[key] === null || data[key] === '') {
                delete data[key];
            }
        }

        // 设置TMS API baseURL
        const originalBaseURL = Axios.defaults.baseURL;
        Axios.defaults.baseURL = TMS_API_ROOT;

        // 发送POST请求，不需要token和sign鉴权
        return Axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
                'project': 'TMS'
            }
        })
            .finally(() => {
                // 恢复原始baseURL
                Axios.defaults.baseURL = originalBaseURL;
            });
    },
    postPermission(data) {
        // 专门用于ppr/api/permission接口的表单传参POST方法
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "/ppr/api/permission";
        let salt = new Date().getTime();
        let sign = this.getdatasign(secret, token, action, salt)

        // 创建URLSearchParams对象来处理表单数据
        let param = new URLSearchParams();
        for (var key in data) {
            // 确保所有值都转换为字符串类型
            param.append(key, String(data[key]));
        }

        // 设置完整的接口URL
        let url = API_USER + "/ppr/api/permission";

        return REQUEST({
            url: url, // ppr/api/permission接口地址
            method: "post", // 请求类型为POST
            data: data, // 以表单数据形式传递参数
            headers: {
                'Content-Type': 'application/json', // 明确指定表单数据格式
                token: token,
                // sign: sign,
            }
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },

    getPushScopeList(data) {
        // 专门用于ppr/rpc/iotSysUser/getUserList接口的表单传参GET方法
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "/ppr/rpc/iotSysUser/getUserList";
        let salt = new Date().getTime();
        let sign = this.getdatasign(secret, token, action, salt)

        // 创建URLSearchParams对象来处理表单数据
        let param = new URLSearchParams();
        for (var key in data) {
            // 确保所有值都转换为字符串类型
            param.append(key, String(data[key]));
        }

        // 设置完整的接口URL
        let url = API_USER + "/ppr/rpc/iotSysUser/getUserList";

        return REQUEST({
            url: url,
            method: "get", // 请求类型为GET
            params: data, // 以表单数据形式传递参数
            headers: {
                'Content-Type': 'application/json', // 明确指定表单数据格式
                token: token,
                // sign: sign,
            }
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    getNew(data) {
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "&action=" + data.action;
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;
        //---------------------------
        let param = new URLSearchParams();
        for (var key in data.form) {
            param.append(key, data.form[key])
        }
        //--------------------------

        return REQUEST({
            url: url, //url地址即/api/system/login
            method: "get", //请求类型post或get
            params: param

        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    postNoSign(urldata) {
        //上传文件
        const salt = new Date().getTime();
        let _dataObj = {};
        for (var key in urldata) {
            let _data = urldata[key];
            let type = (typeof _data === 'string' && (_data !== '')) || (typeof _data === 'number') || (typeof _data === 'boolean')
            if (type) {
                _dataObj[key] = _data.toString()
            }
        }
        let action = Object.keys(_dataObj).map(key => {
            let dat = encodeURIComponent(_dataObj[key]);
            // let dat = _dataObj[key];
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        const url = "?sign=" + this.getdatasign(action, '', '', salt) + "&salt=" + salt + action;
        // post
        return REQUEST({
            url: url, //url地址如/api/system/login
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'  //CCM只能使用此请求头上传exl类型文件， 通用请求头为：multipart/form-data
            },
            method: "post", //请求类型post或get
            //   data: _dataObj //post请求提交的数据对象
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    // postAam(data) {
    //     // post
    //     let secret = sessionStorage.getItem("secret");
    //     let token = sessionStorage.getItem("token");
    //     let action = "&action=" + data.action;
    //     let salt = new Date().getTime();
    //     let url = "?sign=" + this.getdatasign(secret, token, action) + "&salt=" + salt + "&token=" + token + action;
    //     for (let key in data.form) {
    //         if (data.form[key] === undefined || data.form[key] === null || data.form[key] === '') {
    //           delete data.form[key]
    //         }
    //       }
    //       let params = {
    //         ...data.form
    //       }
    //     return REQUEST({
    //         //    headers: {
    //         //        'Content-Type': 'application/json'
    //         //    },
    //             headers: {
    //             'Content-Type': 'text/plain'
    //            },
    //             url: url, //url地址即/api/system/login
    //             method: "post", //请求类型post或get
    //             data: params //post请求提交的数据对象,data则会放在post请求体里面，即post请求的body里面
    //         })
    //         .then(result => this.handleSucc(result))
    //         .catch(error => this.handleError(error));
    // },
    file(urldata, filedata) {
        //上传文件
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        const salt = new Date().getTime();
        let _dataObj = {};
        for (var key in urldata) {
            let _data = urldata[key];
            let type = (typeof _data === 'string' && (_data !== '')) || (typeof _data === 'number') || (typeof _data === 'boolean')
            if (type) {
                _dataObj[key] = _data.toString()
            }
        }
        let action = Object.keys(_dataObj).map(key => {
            // let dat = encodeURIComponent(_dataObj[key]);
            let dat = _dataObj[key];
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        const url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;
        // post
        return REQUEST({
            url: url, //url地址如/api/system/login
            headers: {
                'Content-Type': 'multipart/form-data'  //CCM只能使用此请求头上传exl类型文件， 通用请求头为：multipart/form-data
            },
            method: "post", //请求类型post或get
            data: filedata //post请求提交的数据对象
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    postFile(data) {
        // post
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "&action=" + data.action;
        let salt = new Date().getTime();
        let url = "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;


        return REQUEST({
            headers: {
                'Content-Type': 'multipart/form-data' //之前说的以表单传数据的格式来传递fromdata
            },
            url: url, //url地址即/api/system/login
            method: "post", //请求类型post或get
            data: data.data //post请求提交的数据对象,data则会放在post请求体里面，即post请求的body里面
        })
            .then(result => this.handleSucc(result))
            .catch(error => this.handleError(error));
    },
    postFile2(data) {
        // post
        //      action = encodeURI(action)
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = "&action=uploadFile";
        let salt = new Date().getTime();
        let url = API_ROOT + "?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;


        return url;
    },
    export(data) {
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = Object.keys(data).map(key => {
            let dat = encodeURIComponent(data[key]);
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        let salt = new Date().getTime();
        let url = API_ROOT + "download?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;

        return url
    },


    //postFile2(data) {
    //      // post
    //      let secret = sessionStorage.getItem("secret");
    //      let token = sessionStorage.getItem("token");
    //      let action = "&action=" + data.action;
    //      let salt = new Date().getTime();
    //      let url1 =API_ROOT+ "?sign=" + this.getdatasign(secret, token, action) + "&salt=" + salt + "&token=" + token + action;
    //
    //      return  url1;
    //  },
    //  export (data) {
    //      let secret = sessionStorage.getItem("secret");
    //      let token = sessionStorage.getItem("token");
    //      let action = Object.keys(data).map(key => {
    //          let dat = encodeURIComponent(data[key]);
    //          dat = dat.replace(/%40/g, '@');
    //          dat = dat.replace(/%3A/g, ':');
    //          dat = dat.replace(/%24/g, '$');
    //          dat = dat.replace(/%2C/g, ',');
    //          dat = dat.replace(/%20/g, '+');
    //          dat = dat.replace(/%5B/g, '[');
    //          dat = dat.replace(/%5D/g, ']');
    //          return "&" + key + "=" + dat;
    //      }).join('');
    //      let salt = new Date().getTime();
    //      let url = API_ROOT + "download?sign=" + this.getdatasign(secret, token, action) + "&salt=" + salt + "&token=" + token + action;
    //
    //      return url
    //  },



    //  
    //     postFile3(data) {
    // 		// post
    // 		let secret = sessionStorage.getItem("secret");
    // 		let token = sessionStorage.getItem("token");
    // 		let action = data.action;
    // 		let signparams = Object.keys(data).map(key => {
    // 			let dat = ''
    // 			if(typeof data[key] == 'object') {
    // 				let arrKey = [];
    // 				let arrVal = [];
    // 				for(var childkey in data[key]) {
    // 					arrKey.push(childkey);
    // 					arrVal.push(data[key][childkey]);
    // 				}
    // 				for(var i = 0; i < arrVal.length; i++) {
    // 					dat += "&" + arrKey[i] + "=" + arrVal[i];
    // 				}
    // 				return dat
    // 			} else {
    // 				let dat = encodeURIComponent(data[key]);
    // 				dat = dat.replace(/%40/g, '@');
    // 				dat = dat.replace(/%3A/g, ':');
    // 				dat = dat.replace(/%24/g, '$');
    // 				dat = dat.replace(/%2C/g, ',');
    // 				dat = dat.replace(/%20/g, '+');
    // 				dat = dat.replace(/%5B/g, '[');
    // 				dat = dat.replace(/%5D/g, ']');
    // 				return "&" + key + "=" + dat;
    // 			}
    // 		}).join('');
    // 		let salt = new Date().getTime();
    // 		let url = "ws?sign=" + this.getdatasign(secret, token, utils.ParamSort(signparams)) + "&salt=" + salt + "&token=" + token + '&action=' + action;
    // 		let param = new URLSearchParams();
    // 		for(var key in data.form) {
    // 			param.append(key, data.form[key])
    // 		}
    // 		return REQUEST({
    // 				url: url, //url地址即/api/system/login
    // 				method: "post", //请求类型post或get
    // 				data: param //post请求提交的数据对象,data则会放在post请求体里面，即post请求的body里面
    // 			})
    // 			.then(result => this.handleSucc(result))
    // 			.catch(error => this.handleError(error));
    // 	},
    // 	export default {
    // 		//接口参数排序，方便计算签名
    // 		ParamSort(param) {
    // 			var strs = param.split("&");
    // 			strs.sort();
    // 			var sortAfter = "";
    // 			for(var i = 0; i < strs.length; i++) {
    // 				sortAfter += strs[i] + "&";
    // 			}
    // 			if(sortAfter.length > 0) {
    // 				sortAfter = sortAfter.substr(0, sortAfter.length - 1);
    // 			}
    // 			return sortAfter;
    // 		}
    // 	}
    export(data) {
        let secret = sessionStorage.getItem("secret");
        let token = sessionStorage.getItem("token");
        let action = Object.keys(data).map(key => {
            let dat = encodeURIComponent(data[key]);
            dat = dat.replace(/%40/g, '@');
            dat = dat.replace(/%3A/g, ':');
            dat = dat.replace(/%24/g, '$');
            dat = dat.replace(/%2C/g, ',');
            dat = dat.replace(/%20/g, '+');
            dat = dat.replace(/%5B/g, '[');
            dat = dat.replace(/%5D/g, ']');
            return "&" + key + "=" + dat;
        }).join('');
        let salt = new Date().getTime();
        let url = API_ROOT + "download?sign=" + this.getdatasign(secret, token, action, salt) + "&salt=" + salt + "&token=" + token + action;
        return url
    },
    getNoAuth(action, data) {
        let _dataObj = {};
        let _dataObj1 = {};

        // 将传入的 data 对象分别处理成基本类型和数组类型的数据
        for (var key in data) {
            let _data = data[key];
            if (typeof _data === 'string' && _data !== '') {
                _dataObj[key] = _data.toString();
            } else if (Array.isArray(_data) && _data.length !== 0) {
                _dataObj1[key] = _data;
            }
        }

        // 构建请求参数，将基本类型数据转换成字符串形式
        let params = {
            ..._dataObj1,
            ..._dataObj
        };
        let url = API_GISURL + action;
        return REQUEST({
            url: url, // 填写你的请求 URL
            method: 'get',
            params,
            paramsSerializer: params => qs.stringify(params, { indices: false })
        })
    },
    getloginsign(pwd, action, salt) {
        let signstr = salt + pwd + encodeURI(action);
        let loginSign = encryption.sha1(signstr);
        return loginSign
    },
    getdatasign(secret, token, action, salt) {
        console.log(salt);
        console.log(secret);
        console.log(token);
        console.log(action);

        let signstr = salt + secret + token + action;
        console.log(signstr);

        let dataSign = encryption.sha1(signstr);
        return dataSign
    },

    sha1(str) {
        str = encryption.sha1(str);
        return str
    },
    rc4(str, key) {
        str = encryption.rc4(str, key);
        return str
    },
    byte2hex(str) {
        str = encryption.byte2hex(str);
        return str
    },
    handleSucc(result) {
        return result.data
    },
    handleError(error) {
        console.log("请求失败")
    },
};

//export default api;

export default service;


// WEBPACK FOOTER //
// ./src/api/axios.js